// src/pages/DerechoCivilPage.js (MIGRADO A REACT ROUTER)

import React, { useState } from 'react';
// 🛑 IMPORTACIÓN DE useNavigate
import { FiArrowLeft, FiChevronDown, FiChevronUp, FiUsers, FiHome, FiTool } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom'; // ✅ Importado
import '../styles/ServicesCommon.css'; 
import './DerechoCivilStyles.css';

// Componente reutilizable para el contenido desplegable (Acordeón)
const AccordionItem = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="accordion-item">
            <button className="accordion-title" onClick={() => setIsOpen(!isOpen)}>
                {title}
                {isOpen ? <FiChevronUp size={20} /> : <FiChevronDown size={20} />}
            </button>
            {isOpen && <div className="accordion-content">{children}</div>}
        </div>
    );
};

// Datos organizados por categoría para el acordeón de DERECHO CIVIL
const DERECHO_CIVIL_SECTIONS = [
    {
        category: "Derecho Familiar y Matrimonial",
        icon: <FiUsers size={22} />,
        items: [
            {
                title: "Divorcios y Divorcios 185-A",
                content: `Gestión integral de divorcios convencionales (división de bienes, custodia, pensiones) y tramitación bajo el Artículo 185-A del Código Civil venezolano (mutuo acuerdo, rápido y simple). Proceso claro y compasivo.`,
            },
            {
                title: "Divorcio por Desafecto",
                content: `Servicio diseñado para parejas que deciden terminar el matrimonio por pérdida de afecto, permitiendo un proceso más ágil y menos conflictivo. Gestionable vía Internet (incluso si un cónyuge está fuera del país).`,
            },
            {
                title: "Acción Mero-Declarativa de Concubinato",
                content: `Procedimiento legal para obtener el reconocimiento oficial de una relación estable y pública no matrimonial. Fundamental para proteger derechos patrimoniales y personales (herencias, pensiones).`,
            },
            {
                title: "Separación de Cuerpo y de Bienes",
                content: `Permite a los cónyuges vivir separados sin disolver el matrimonio, estableciendo acuerdos sobre convivencia y administración independiente de propiedades.`,
            },
        ]
    },
    {
        category: "Derecho de Propiedad y Contratos",
        icon: <FiHome size={22} />,
        items: [
            {
                title: "Prescripción Adquisitiva (Demandas y Defensas)",
                content: `Asesoría y representación para adquirir la propiedad de un bien a través del uso y posesión continua durante el tiempo legalmente determinado (usucapión), conforme a la legislación venezolana.`,
            },
            {
                title: "Deslindes de Propiedades Contiguas (Demandas y Defensas)",
                content: `Delimitación y definición de límites entre propiedades contiguas, resolviendo disputas sobre la propiedad y el uso del terreno, asegurando un proceso legal adecuado.`,
            },
            {
                title: "Acción Reivindicatoria (Demandas y Defensas)",
                content: `Recuperación de la posesión de bienes que han sido despojados o que están en poder de terceros sin justificación legal. Restablecemos sus derechos sobre el bien.`,
            },
            {
                title: "Comodato y Mutuo (Demandas y Defensas)",
                content: `Asesoría legal para contratos de préstamo: comodato (uso gratuito de bien) y mutuo (préstamo de dinero o fungibles). Incluye redacción, ejecución y resolución de disputas.`,
            },
            {
                title: "Venta con Usufructo y Renta Vitalicia",
                content: `Asesoría en contratos de venta donde el vendedor mantiene el derecho de uso (usufructo) y para la creación de contratos que garantizan pagos periódicos de por vida (renta vitalicia).`,
            },
            {
                title: "Constitución de Hogar, Servidumbres, Uso y Habitación",
                content: `Asesoría para establecer derechos sobre bienes inmuebles, incluyendo formalización de hogar familiar, servidumbres y derechos de uso y habitación, garantizando su validez legal.`,
            },
            {
                title: "Cesión de Bienes, Créditos y Derechos; Donaciones y Dación en Pago",
                content: `Asesoría para la transferencia legal de propiedad (cesiones, donaciones gratuitas) y la resolución de obligaciones mediante la entrega de bienes en lugar de pago en efectivo (dación en pago).`,
            },
        ]
    },
    {
        category: "Acciones y Nulidades Procesales",
        icon: <FiTool size={22} />,
        items: [
            {
                title: "Entregas Materiales (Demandas y Defensas)",
                content: `Presentación y notificación formal de demandas y defensas en procesos legales, asegurando el cumplimiento de los plazos establecidos por la ley.`,
            },
            {
                title: "Nulidades (Demandas y Defensas) y Nulidad de Venta",
                content: `Especialización en declarar la nulidad de actos jurídicos o contratos de compraventa que carecen de validez (vicios, incapacidad, etc.) para proteger sus intereses.`,
            },
            {
                title: "Invalidación de Juicios (Demandas y Defensas)",
                content: `Revisión e impugnación de sentencias o decisiones judiciales que puedan ser consideradas injustas o erróneas, solicitando la nulidad de procesos judiciales.`,
            },
            {
                title: "Interdictos (Demandas y Defensas)",
                content: `Protección inmediata de derechos y bienes a través de medidas cautelares para impedir actos que puedan causar daño o perjuicio, o defensa contra acciones similares.`,
            },
            {
                title: "Amparos",
                content: `Presentación de recursos de amparo para salvaguardar derechos fundamentales (vida, libertad, propiedad) frente a actos de autoridad que puedan vulnerarlos.`,
            },
            {
                title: "Acción de Simulación (Demandas y Defensas)",
                content: `Impugnación de actos jurídicos con apariencia engañosa que no reflejan la verdadera intención de las partes, buscando la nulidad y la transparencia contractual.`,
            },
            {
                title: "Daños Morales, Materiales y Perjuicios (Demandas y Defensas)",
                content: `Asesoría legal en la reclamación y defensa por perjuicios económicos, emocionales o psicológicos causados por actos ilícitos o incumplimientos contractuales.`,
            },
        ]
    }
];

// 🛑 ELIMINAMOS setActivePage de las props
const DerechoCivilPage = () => {
    const navigate = useNavigate(); // ✅ Inicializamos useNavigate

    return (
        <div className="page-container civil-page">
            <header className="civil-header">
                <FiUsers size={40} className="civil-icon" />
                <h1>Derecho Civil, Familiar y de Propiedad</h1>
                <p className="civil-summary">
                    Ofrecemos una asesoría legal integral en todos los aspectos del Derecho Civil venezolano, abarcando temas sensibles como **Divorcios y Concubinato**, **Derechos de Propiedad** (prescripción, deslindes) y la gestión de **Contratos y Acciones Procesales** que protegen su patrimonio y sus derechos fundamentales.
                </p>
                
                <div className="cta-box">
                    <p>Necesitas asesoría en Derecho Civil o Familiar?</p>
                    <button 
                        className="cta-button primary"
                        onClick={() => window.open('https://wa.me/14078738172?text=Necesito%20asesor%C3%ADa%20legal%20en%20Derecho%20Civil%20o%20Familiar.', '_blank')}
                    >
                        Solicitar Consulta
                    </button>
                </div>
            </header>

            <h2 className="section-title">Nuestra Cartera de Servicios de Derecho Civil</h2>
            
            <div className="accordion-container">
                {DERECHO_CIVIL_SECTIONS.map((section, index) => (
                    <div key={index} className="accordion-section-group">
                        <h3 className="section-group-title">
                            {section.icon} {section.category}
                        </h3>
                        {section.items.map((item, i) => (
                            <AccordionItem key={i} title={item.title}>
                                <p>{item.content}</p>
                            </AccordionItem>
                        ))}
                    </div>
                ))}
            </div>

            <footer className="footer-note">
                <p className="note-text">
                    <span className="note-bold">Nuestro Enfoque:</span> Sensibilidad y rigor legal para proteger sus derechos personales y patrimoniales bajo la legislación venezolana.
                </p>
            </footer>
            
            {/* 🚀 BOTÓN "Volver a Servicios" CORREGIDO */}
            <button className="back-button" onClick={() => navigate('/servicios')}>
                <FiArrowLeft /> Volver a Servicios
            </button>
        </div>
    );
};

export default DerechoCivilPage;